import { render, staticRenderFns } from "./FormEmailOrPhone.vue?vue&type=template&id=43385ce6"
import script from "./FormEmailOrPhone.vue?vue&type=script&lang=js"
export * from "./FormEmailOrPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports